import { render } from "./LinkedSearchObject.vue?vue&type=template&id=27a3e920"
import script from "./LinkedSearchObject.vue?vue&type=script&lang=js"
export * from "./LinkedSearchObject.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__